import React, { useState } from 'react';
import reactUpdate from 'react-addons-update';
import _ from 'underscore';
import xtend from 'xtend';
import RestrictedComponent from '../../../../lib/components/form/RestrictedComponent';
import schema from '../../../../routes/permissions/schema';

const GeneralTab = props => {
    const [edited, setEdited] = useState(false)
    const [edits, setEdits] = useState({})

    // const transferState = () => {
    //     if (!edited) {
    //         var { encoder } = props;
    //         setEdited(true)
    //         setEdits(_.pick(encoder,
    //             'streamName',
    //             'description',
    //             'simpleName'
    //         ))
    //     }
    // }

    const handleChange = (event) => {
        // transferState();
        var { value, name } = event.target;
        var updates = {
            ...{
                streamName: encoder.streamName,
                description: encoder.description,
                simpleName: encoder.simpleName
            },
            ...edits,
            ...{[name]: value}
        };
        // updates[name] = {$set: value};
        setEdits(updates)
        setEdited(true)
    }

    const handleSave = () => {
        var { encoder } = props;

        props.actions.edit(xtend({
            encoderID: encoder.encoderID
        }, edits), function (err, resp) {
            if (err) console.warn(err);
            props.emitSnack({
                type: 'success',
                message: 'Encoder Updated'
            });
        });

        revert();
    }

    const revert = () => {
        setEdits({})
        setEdited(false)
    }

    var { encoder } = props;
    var simpleName = (edited) ? edits.simpleName : encoder.simpleName;
    var description = (edited) ? edits.description : encoder.description;
    var streamName = (edited) ? edits.streamName : encoder.streamName;

    return (<div className="col-xs-12 tab-content">
        <div className="col-md-12 form-elements">
            <label>Title:</label>
            <input className="form-control" type="text" name="simpleName" value={simpleName} onChange={handleChange}/>

            <label>Description:</label>
            <textarea className="form-control" name="description" value={description || ''} onChange={handleChange}/>

            <label>Stream Name:</label> <small>(Stream Name will be auto generated if left blank or is already taken)</small>
            <input className="form-control" type="text" name="streamName" value={streamName} onChange={handleChange}/>
        </div>
        <div className="col-md-12 form-actions">
            <button className="btn btn-default" disabled={!edited} onClick={revert}>
                <i className="fa fa-undo"/> Reset
            </button>
            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_ENCODERS.UPDATE}>
                <button className="btn btn-success" disabled={!edited} onClick={handleSave}>
                    <i className="fa fa-save"/> Save
                </button>
            </RestrictedComponent>
        </div>
    </div>);
}

export default GeneralTab;
